<template>
    <section class="stylish text-center">
        <!-- Start Overlay -->
        <div class="overlay">
            <h1 class="text-uppercase">Stylish Axure Design</h1>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
            <button class="download">Download</button>
        </div>
        <!-- End Overlay -->
    </section>
</template>

<style scoped lang="scss">

    .stylish{
        background: url("../../assets/images/buildings.jpg") no-repeat center center fixed;
        background-size: cover;
        color: #FFF;
        .overlay{
            padding: var(--main-padding);
            h1{
                position: relative;
                margin-bottom: 50px;
                &::after{
                    content: '';
                    position: absolute;
                    bottom: -25px;
                    left: calc(50% - 50px);
                    width: 100px;
                    height: 3px;
                    background-color: #FFF
                }
            }

            p{
                color: var(--second-background)
            }
            button.download{
                background-color: transparent;
                color: #FFF;
                border: 2px solid #FFF;
                padding: 5px 20px;
                transition: .5s;
                &:hover{
                    background-color: #FFF;
                    color: #000
                }
            }
        }
    }

</style>

<script>

export default {

    name: "Stylish"
    
}

</script>